<template>
  <div class="load load--fill content-section-loader" />
</template>

<script type="text/babel">
export default {
  name: 'ContentSectionLoader',
}
</script>

<style scoped>
.content-section-loader {
  min-height: 50vh
}
</style>
